// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useCallback, useRef} from 'react';
import cn from 'classnames';
import {use_win_scroll} from '../../utils/hooks.js';
import {Popup} from '../popup';
import {Text} from '../text';
import {Button} from '../button';
import './context_menu.less';

function Item({item, on_select}){
    const btn_ref = useRef();
    const handle_click = useCallback(()=>{
        on_select(item.id);
        if (item.on_click)
            item.on_click(item);
    }, [item.id, item.on_click]);
    return <li className="ea_context_menu_item">
      <button className="ea_context_menu_button" onClick={handle_click}
        ref={btn_ref} disabled={item.disabled}>
        <Text.s className="ea_context_menu_text">{item.title}</Text.s>
      </button>
    </li>;
}

const normalize = items=>{
    return items.map(i=>{
        if (typeof i=='string')
            return {id: i, title: i};
        return i;
    });
};

export function Context_menu({
    items: _items=[],
    className,
    on_change,
    disabled,
    width,
    tip='Edit',
    ico='edit',
    color_scheme='tertiary',
})
{
    const items = normalize(_items);
    const wrapper_ref = useRef();
    const [opened, set_opened] = useState(false);
    const [coors, set_coords] = useState(null);
    const [popup_h, set_popup_h] = useState(null);
    const toggle = useCallback(()=>{
        requestAnimationFrame(()=>{
            const node = wrapper_ref.current;
            if (!node)
                return;
            const {x, y, height} = node.getBoundingClientRect();
            const v_start = y+height+8;
            set_coords({x, y: v_start});
            set_popup_h(window.innerHeight-v_start-24);
            set_opened(v=>!v);
        });
    }, []);
    const handle_select = useCallback(id=>{
        toggle();
        on_change?.(id);
    }, []);
    const handle_click = useCallback(e=>e.stopPropagation(), []);
    const is_trigger_disabled = disabled || !items.length;
    const handle_scroll = useCallback(()=>set_opened(false), []);
    use_win_scroll(handle_scroll);
    return <div ref={wrapper_ref} className={cn('ea_context_menu', className)}
      onClick={handle_click}>
      <Button className="ea_context_menu_trigger" on_click={toggle}
        disabled={is_trigger_disabled} ico={ico} size="xs" filled
        color_scheme={color_scheme} tip={tip} tip_placement="right">
      </Button>
      <Popup show={opened} hide_header hide_actions on_close={toggle}
        coords={coors} width={width||128} max_height={popup_h} no_padding
        no_backdrop has_shadow>
        <div className="ea_context_menu_popup">
          <ul className="ea_context_menu_list">
            {items.map(i=><Item key={i.id} item={i}
              on_select={handle_select}/>)}
          </ul>
        </div>
      </Popup>
    </div>;
}
